<template>
  <div class="notfound-page">
    <!-- <div class="mars"></div> -->
    <!-- <img src="./image/404.svg" class="logo-404" /> -->
    <!-- <p class="title">404</p> -->
    <p class="subtitle">
      {{website}}
    </p>
    <router-link to="/home" class="btn-back">
      Back to Home
    </router-link>
    <!-- <p class="subtitle">
      {{errmsg}}
    </p> -->
    <!-- <img src="./image/astronaut.svg" class="astronaut" /> -->
    <!-- <img src="./image/spaceship.svg" class="spaceship" /> -->
    <p class="gameTitle">Here's what you've found：</p>
    <new-home-block></new-home-block>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import newHomeBlock from '../../components/new-home/new-home'

export default {
  name: 'notfound',
  components: {
    newHomeBlock,
  },  
  data() {
    return {
      errmsg:'页面不存在您来到了没有游戏的荒野',
      website:'',
    }
  },
  computed: {
    ...mapState({
      errorMsg: state => state.errorMsg
    })
  },
  mounted() {
    if(this.$route.query.err){
      this.errmsg = this.$route.query.err
    }    
    this.website = window.location.pathname.substr(1);
  },
  created() {
    let path = window.location.pathname;
    document.title = path.substr(1) + '- The Best India Cricket & Game site';
    
  },
  destroyed() {
    
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Nunito:400,600,700");
@keyframes floating {
  from {
    transform: translateY(0px);
  }
  65% {
    transform: translateY(15px);
  }
  to {
    transform: translateY(0px);
  }
}


.notfound-page {
  min-height: 100vh;
  background-image: url("./image/star.svg"),
    linear-gradient(to bottom, #05007a, #4d007d);
  margin: 0;
  background-attachment: fixed;
  overflow: hidden;
}

.mars {
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  height: 27vmin;
  background: url("./image/mars.svg") no-repeat bottom center;
  background-size: cover;
}

.logo-404 {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 16vmin;
  width: 30vmin;
}
@media (max-width: 480px) and (min-width: 320px) {
  .logo-404 {
    top: 45vmin;
  }
}

.meteor {
  position: absolute;
  right: 2vmin;
  top: 16vmin;
}

.title {
  color: white;
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  text-align: center;
  font-size: 5vmin;
  margin-top: 11vmin;
}
@media (max-width: 480px) and (min-width: 320px) {
  .title {
    margin-top: 65vmin;
  }
}

.subtitle {
  color: white;
  font-family: "Nunito", sans-serif;
  font-weight: 400;
  text-align: center;
  font-size: 3.5vmin;
  margin-top: 2vmin;
  margin-bottom: 2vmin;
}

.gameTitle{
  width: 1500px;
  margin: 20px auto 30px;
  color: rgb(216, 237, 26);
  font-size: 24px;
}
.btn-back {
    display: block;
  border: 1px solid white;
  color: white;
  margin: 0 auto 40px;
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-family: "Nunito", sans-serif;
  text-decoration: none;
  border-radius: 5px;
  font-size: 15px;
}
.btn-back:hover {
  background: white;
  color: #4d007d;
}
@media (max-width: 480px) and (min-width: 320px) {

}

.astronaut {
  position: absolute;
  top: 18vmin;
  left: 10vmin;
  height: 30vmin;
  animation: floating 3s infinite ease-in-out;
}
@media (max-width: 480px) and (min-width: 320px) {
  .astronaut {
    top: 2vmin;
  }
}

.spaceship {
  position: absolute;
  bottom: 15vmin;
  right: 24vmin;
}
@media (max-width: 480px) and (min-width: 320px) {
  .spaceship {
    width: 45vmin;
    bottom: 18vmin;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build902/views/notfound/404.vue